document.addEventListener("DOMContentLoaded", function () {
  // Latest News Swiper
  const latestNewsSlider = document.querySelector(".latest-news-swiper");
  if (latestNewsSlider) {
    const latestSwiper = new Swiper(latestNewsSlider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {
          toggleNavVisibility(this, latestNewsSlider);
        },
        resize: function () {
          toggleNavVisibility(this, latestNewsSlider);
        },
      },
    });

    function toggleNavVisibility(swiper, container) {
      // const totalSlides = swiper.slides.length;
      // const windowWidth = window.innerWidth;
      // let currentSlidesPerView = 1;
      // if (windowWidth >= 992) {
      //   currentSlidesPerView = 3;
      // } else if (windowWidth >= 768) {
      //   currentSlidesPerView = 2;
      // }
      // const showNav = totalSlides > currentSlidesPerView;
      // const nextBtn = container.querySelector(".swiper-button-next");
      // const prevBtn = container.querySelector(".swiper-button-prev");
      // if (nextBtn && prevBtn) {
      //   nextBtn.style.display = showNav ? "block" : "none";
      //   prevBtn.style.display = showNav ? "block" : "none";
      // }
    }
  }

  const otherSwiper = document.querySelector(".mySwiper");
  if (otherSwiper) {
    // const totalDots = 4;

    const swiper = new Swiper(otherSwiper, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        // renderBullet: function (index, className) {
        //   if (index < totalDots) {
        //     return `<span class="${className} custom-dot" data-dot-index="${index}"></span>`;
        //   }
        //   return "";
        // },
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoHeight: true,
      // on: {
      //   init: function () {
      //     updateCustomDots(this.realIndex);
      //   },
      //   slideChange: function () {
      //     updateCustomDots(this.realIndex);
      //   },
      // },
    });

    // function updateCustomDots(realIndex) {
    //   const dots = document.querySelectorAll(".swiper-pagination .custom-dot");
    //   const activeIndex = realIndex % totalDots;
    //   dots.forEach((dot, i) => {
    //     dot.classList.toggle(
    //       "swiper-pagination-bullet-active",
    //       i === activeIndex
    //     );
    //   });
    // }
  }
});
